module.exports = __webpack_public_path__ + "static/kommune-intro-img-b46a65d1c91c88da119dede0d0bd4388.png";